type Params = {
  width: number
  height: number
  maxWidth: number
}

const useFitImageDimensions = ({ width, height, maxWidth }: Params) => {
  const ratio = width / maxWidth
  if (ratio < 1) {
    return {
      width,
      height,
    }
  }
  return {
    width: Math.ceil(width / ratio),
    height: Math.ceil(height / ratio),
  }
}

export default useFitImageDimensions
